
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-storage-and-shipping-services",
      function () {
        return require("private-next-pages/student-storage-and-shipping-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-storage-and-shipping-services"])
      });
    }
  